<mf-page title="Logging">
  <mf-grid
    actionButtonText="Configuración"
    [columns]="columns"
    [menuItems]="menuItems"
    [apiEndpoint]="apiEndpoint"
    [useContinuationToken]="true"
    (actionButtonClick)="navigateToConfig()" />
</mf-page>
